import { validateHeapSafely } from '@/metrics/heap.types';
import { type ExposureTracker } from '@resolve_medical_bills/flagsmith/react';

/**
 * Heap delivery for the shared flagsmith package. The package owns the
 * event shape and session dedup; we own delivery and the readiness guard.
 */
export const heapTracker: ExposureTracker = {
  setUserProperty: (key, value) => {
    if (!validateHeapSafely()) return;
    window.heap.addUserProperties({ [key]: value });
  },
  // false → package skips the dedup marker and retries on a later render
  trackExposure: (payload) => {
    if (!validateHeapSafely()) return false;
    window.heap.track('flag-exposure', payload);
    return true;
  },
};
